import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
//引入全局css
import '@/style/global.css'
import wx from "weixin-js-sdk"
//隐藏滚动条
// import '@/style/noscroll.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//全局组件
import typeNav from '@/components/TypeNav'
import webFooter from '@/components/Footer'

Vue.component(typeNav.name,typeNav);
Vue.component(webFooter.name,webFooter);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
Vue.use(ElementUI);

// 挂在vue的原型上方便使用
Vue.prototype.$wx = wx;
Vue.config.productionTip = false
import axios from "axios"
axios.defaults.withCredentials=true;//让ajax携带cookie
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
